module.exports = __webpack_public_path__ + "img/humedad.e24807b8.svg";